import DTProcessReturnThenSendMacro from '../NodeGroups/DTCopyTextSendMacro/DTProcessReturnThenSendMacro/DTProcessReturnThenSendMacro';
import { getShowConfirmationPage } from '../../../selectors/tools';
import { useSelector } from 'react-redux';

const ProcessReturnThenSendMacro = () => {
  const showConfirmationPage = useSelector(getShowConfirmationPage);

  return (
    <DTProcessReturnThenSendMacro showConfirmation={showConfirmationPage} message={'Return has been processed.'} />
  );
};

export default ProcessReturnThenSendMacro;
